import { ThomasAdvertiser } from 'models/interfaces/index';
import { GET_ADVERTISERS_QUERY } from 'containers/ThomasAdvertiserListContainer';
import { ApolloClient } from 'apollo-client';

async function getAdvertisers(client: ApolloClient<any>) {
  //   return await client.query({
  //     query: GET_ADVERTISERS_QUERY
  //   });

  try {
    const data: any = await client
      .query({
        query: GET_ADVERTISERS_QUERY
      })
      .then(x => x);
    //console.log(`advertiser list `, data);
    return data.data.thomasAdvertisers;
  } catch (error) {
    console.log('Failed to retrieve list.');
    return null;
  }
}

const buildAdvertisersOptions = (advertisers: any) => {
  console.log('Begin advertiserOptions - assign template: ');
  console.time('makeAndvertisersOptions');
  const advertiserOptions: any[] = [];
  if (advertisers) {
   // console.log(`advertisers`, advertiserOptions);
    advertisers.then(i => {
      if (i) {
        i.forEach(x => {
          const entry: any = { value: x.tgrams_id, name: x.name };
          advertiserOptions.push(entry);
        });
      }
    });
  }

  console.timeEnd('makeAdvertisersOptions');
 // console.log(`list values`, advertiserOptions);
  return advertiserOptions;
};

export { getAdvertisers, buildAdvertisersOptions };
